<template>
    <div class="container pt-3">
        <div class="gv-container-header d-flex flex-column align-items-center pt-5 justify-content-center text-center">
            <h1 class="display-1 text-muted pt-5"><strong>403</strong></h1>
            <h2 class="title"><strong>Acceso denegado/prohibido</strong></h2>
            <p class="text-muted">La página o el recurso al que intentabas acceder está absolutamente<br> prohibido por alguna razón.</p>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
